import { useState } from "react";
import Slide from "react-reveal/Slide";
import {
  PriceContainer,
  PriceWrapper,
  PriceRow,
  Column1,
  Column2,
  TextWrapper,
  Heading,
  Subtitle,
  CTASection,
  CTAButton,
  ArrowForward,
  ArrowRight,
  ImgWrap,
  Img,
} from "./PriceElements";

const PriceSection = ({ id, headline, imgStart, img, alt, buttonLabel }) => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };
  return (
    <>
      <PriceContainer id={id}>
        <PriceWrapper>
          <PriceRow imgStart={imgStart}>
            <Slide left>
              <Column1>
                <TextWrapper>
                  <Heading>{headline}</Heading>
                  <Subtitle>
                    Our fees are plain and clear. No hidden costs. No contracts.
                  </Subtitle>
                  <Subtitle>
                    From Zero charges to UGX. 10,000 max transaction fees, our
                    pricing is the best in the market.
                  </Subtitle>
                </TextWrapper>

                <CTASection>
                  <CTAButton
                    onClick={() =>
                      window.open(
                        "https://drive.google.com/file/d/1lPwMt9Ab3Al9oxfVsOS60S1vSwgQBsDC/view?usp=sharing",
                        "_blank"
                      )
                    }
                    onMouseEnter={onHover}
                    onMouseLeave={onHover}
                  >
                    {buttonLabel}
                    {hover ? <ArrowForward /> : <ArrowRight />}
                  </CTAButton>
                </CTASection>
              </Column1>
            </Slide>
            <Column2>
              <ImgWrap>
                <Img src={img} alt={alt} />
              </ImgWrap>
            </Column2>
          </PriceRow>
        </PriceWrapper>
      </PriceContainer>
    </>
  );
};

export default PriceSection;
